export default __webpack_public_path__ + "static/media/bg-ban.645fbe9a.png";